import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ListTreeComponent } from '@app/shared/components/list-tree/list-tree.component';

@Component({
  selector: 'app-list-tree-dialog',
  templateUrl: './list-tree-dialog.component.html',
  styleUrls: ['./list-tree-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListTreeDialogComponent implements OnInit {
  title?: string;
  treeData: Node[] = [];

  @ViewChild('listTree') tree!: ListTreeComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ListTreeDialogComponent>,
  ) {}

  ngOnInit() {
    this.title = this.data.title;
    this.treeData = this.data.treeData;
  }

  cancel() {
    this.matDialogRef.close();
  }

  save() {
    if (this.tree.selectedNodes.length > 0) {
      this.matDialogRef.close(this.tree.selectedNodes);
    }
  }
}
